interface Props {
  value?: boolean | null;
}

export default function StatusLabel({ value }: Props) {
  return (
    !value ?
      <span className="badge bg-danger">Inactivo</span>
      :
      <span className=" badge bg-success">Activo</span>
  )
}